/** How long colleague/resource schedule GET results stay fresh (react-query `staleTime`). */
export const SCHEDULE_QUERY_STALE_TIME_MS = 60_000;
